export default "__VITE_ASSET__DXmEg$tS__"